<!-- src/app/notifications/notifications-page/notifications-page.component.html -->
<div class="notifications-page">
  <app-notification-list></app-notification-list>
</div>